import { render } from "./ColorInputPopup.vue?vue&type=template&id=3aff1ede&scoped=true"
import script from "./ColorInputPopup.vue?vue&type=script&lang=js"
export * from "./ColorInputPopup.vue?vue&type=script&lang=js"

import "./ColorInputPopup.vue?vue&type=style&index=0&id=3aff1ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aff1ede"]])

export default __exports__